import { Routes, Route, Navigate } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import initialTheme from "theme/theme";
import { AuthProvider } from "contexts/AuthContext";
import { PrivateRoute } from "routes/PrivateRoute";
import PartnerLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import Dashboard from "views/partner/dashboard";
import TasksList from "views/partner/tasks/TasksList";
import TaskDetail from "views/partner/tasks/TaskDetail";
import PartnerProfile from "views/partner/profile";
import Support from "views/partner/support";
import SupportTicketDetail from "views/partner/support/SupportTicketDetail";

const App = () => {
  return (
    <ChakraProvider theme={initialTheme}>
      <AuthProvider>
        <Routes>
          <Route path="auth/*" element={<AuthLayout />} />
          <Route
            path="/partner"
            element={
              <PrivateRoute>
                <PartnerLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="orders" element={<TasksList />} />
            <Route path="orders/:taskId" element={<TaskDetail />} />
            <Route path="profile" element={<PartnerProfile />} />
            <Route path="support/:ticketId" element={<SupportTicketDetail />} />
            <Route path="support" element={<Support />} />
          </Route>
          <Route path="/" element={<Navigate to="/partner/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/partner/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </ChakraProvider>
  );
};

export default App;
